import React from "react";
import { Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { FaArrowRight } from "react-icons/fa";


const CheckoutSteps = ({ step2, step4 }) => {
  return (
    <Nav  style={{ justifyContent: 'space-around', display: 'flex', width: '100%',marginBottom:"20px" }}>
      <Nav.Item>
        {step2 ? (
          <LinkContainer to="/shipping-payment">
            <Nav.Link className="inline-block px-2 py-1 text-sm whitespace-nowrap md:px-4 md:py-2">
              Shipping
            </Nav.Link>
          </LinkContainer>
        ) : (
          <Nav.Link disabled className="inline-block px-2 py-1 text-sm whitespace-nowrap md:px-4 md:py-2">
            Shipping
          </Nav.Link>
        )}
      </Nav.Item>
      <Nav.Item style={{ display: "flex", alignItems: "center", padding: "0 8px", fontWeight: "500", color:"#8B7355"}}>
        &gt;
      </Nav.Item>

      <Nav.Item>
        {step4 ? (
          <LinkContainer to="/placeorder">
            <Nav.Link className="inline-block px-2 py-1 text-sm whitespace-nowrap md:px-4 md:py-2">
              Place order
            </Nav.Link>
          </LinkContainer>
        ) : (
          <Nav.Link disabled className="inline-block px-2 py-1 text-sm whitespace-nowrap md:px-4 md:py-2">
            Place order
          </Nav.Link>
        )}
      </Nav.Item>
    </Nav>
  );
};

export default CheckoutSteps;
